export default __webpack_public_path__ + "static/media/product4.78f928b0.jpg";